/* eslint-disable @nx/enforce-module-boundaries */
import { inject, Injectable } from '@angular/core';
import {
  ProductsWMSFilterModel,
  ProductWMSListModel
} from '@kanzi-apes/kanzi-models';
import { KanziRestClientService } from '@kanzi-apes/kanzi-rest-api';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductLineWmsService {
  private httpClient = inject(KanziRestClientService);
  private envService = inject(EnvironmentService);

  private productsV3Url = `${this.envService.wmsEnvironment?.apiRestModules.kongWMSAPI?.productsV3?.apiURL ?? ''}`;
  private productsV3Path = `${this.envService.wmsEnvironment?.apiRestModules.kongWMSAPI?.productsV3?.apiPath ?? ''}`;

  /**
   * Retrieves a list of products from the V3 endpoint.
   * @param filters - Filters to apply to the list including limit and offset
   * @returns Observable with the product list
   */
  getProductList(
    filters: ProductsWMSFilterModel | null
  ): Observable<ProductWMSListModel> {
    const url = `${this.productsV3Url}${this.productsV3Path}`;
    return this.httpClient.get(
      url,
      filters,
      'Error al listar los productos',
      {},
      { tokenName: 'KanziWMSUserToken', tokenPrefix: 'COGNITO' }
    );
  }
}
